import {
    AccordionProps,
    Accordion,
    AccordionDetailsProps,
    AccordionDetails,
    styled,
    Divider,
    DividerProps,
    Box,
    BoxProps,
} from "@mui/material";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";

export const StyledAccordion = styled(Accordion)<AccordionProps>(({ theme: muiTheme }) => {
    const theme = muiTheme as SenecBaseTheme;

    return {
        width: "100%",
        boxShadow: "none",
        "& .MuiAccordionSummary-root": {
            padding: 0,
            "&.Mui-expanded": {
                minHeight: "0px",
            },

            "& .MuiAccordionSummary-content": {
                margin: "16px 0px",
            },
            "& .MuiAccordionSummary-expandIconWrapper": {
                color: theme.palette.neutralGray100.main,
            },
        },
    };
});

export const StyledAccordionDetails = styled(AccordionDetails)<AccordionDetailsProps>(() => {
    return {
        padding: 0,
    };
});

export const StyledDivider = styled(Divider)<DividerProps>(({ theme: muiTheme }) => {
    const theme = muiTheme as SenecBaseTheme;

    return {
        width: "100%",
        borderColor: theme.palette.neutralGray30.main,
    };
});

export const StyledSummaryBox = styled(Box)<BoxProps>(() => {
    return {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        marginRight: "24px",
    };
});
